import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Select, Row, Col } from 'antd';
import IntlMessages from '../../../components/utility/intlMessages';
import actions from '../../redux/accounts/actions';
import AddAccount from './AddUserAccount';
import AccessControl from '../access/AccessControl';
const Option = Select.Option;

class UserAccountMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visiblity: false,
      accounts: null,
      retries: 0,
    };
  }

  componentDidUpdate(prevProps) {
    const { accounts, activeAccount, switchAccount } = this.props;
    if (prevProps?.accounts !== accounts && accounts?.length > 0 && (!activeAccount || Object.keys(activeAccount)?.length < 1)) {
      switchAccount(accounts[0].clientId);
    }
  }

  componentDidMount() {
    if (!this.props.accounts || this.props.accounts.length === 0) {
      this.props.fetchAccounts();
    }
  }

  render() {
    const { accounts, activeAccount, switchAccount } = this.props;

    return (
      accounts?.length > 1 &&
      <Row type="flex" justify="space-around" align="middle">
        <Col xs={6} style={{ textAlign: 'center' }}>
          {<IntlMessages id={'topbar.account'} />}:
        </Col>
        <Col xs={14} >
          <Select
            showSearch
            showArrow={false}
            optionFilterProp="children"
            filterOption={(input, option) => option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            value={activeAccount && Object.keys(activeAccount).length > 0 ? activeAccount.clientId : ''}
            style={{ width: '12.2rem', paddingRight: '2rem' }}
            onChange={switchAccount}
            disabled={accounts.length < 2}
          >
            {
              accounts.map((account, i) => (
                <Option title={account.name || ''} key={i} value={account.clientId}>{account.name}</Option>
              ))
            }
          </Select>
        </Col>
        <Col xs={4}>
          <AccessControl admin={true} allowedPermissions={["ADD_ACCOUNTS"]}>
            <AddAccount />
          </AccessControl>
        </Col>
      </Row >
    );
  }
}

const mapStateToProps = (state) => ({
  accounts: state.Accounts.accounts,
  activeAccount: state.Accounts.activeAccount,
  admin: state.Auth.user && state.Auth.user.isSuperAdmin,
  userPermissions: state.Auth.user && state.Auth.user.permissions,
});


const mapDispatchToProps = (dispatch) => ({
  switchAccount: (value) => {
    dispatch({ type: actions.SWITCH_ACCOUNT, accountId: value });
    dispatch({ type: 'FETCH_CLIENTS', account: value });
  },
  fetchAccounts: () => dispatch(actions.fetchAccounts()),
});



export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAccountMenu);
